import { search_asp, trimFieldString } from "../util.js";

export function translateAggregate(tech, args, line, parsed, source, mapping, processed, config) {
  let rules = [];
  let subTech = args[0];
  if (subTech === 'aggregate_q_pos_X_n_pos') {
    let layer_index = mapping[args[1]]["layer"];
    let rcKey = mapping[args[2]];
    let rc = ("layout.column" in rcKey ? "column" : "row");
    let rcField = source?.layout?.[rc]?.[rcKey["layout." + rc]];
    if (rcField.constructor.name === "Array") rcField = rcField[0];
    rcField = rcField.field || rcField;
    if (rcField) {
      let rule = {
        category: "recommender",
        description: `Aggregate ${rc}`,
        specifier: {
          role: "view." + rc,
          field: rcField
        },
        action: "modify",
        option: {}
      }
      if (source.layer.length > 1) {
        rule.specifier.layer = { index: layer_index };
      }
      if (search_asp(parsed, `recommended_aggregate("${rcField}",sum)`).length >= 0) {
        rule.option.aggregate = "sum";
      } else {
        rule.option.aggregate = "mean";
      }
      rules.push(rule);
    }
  }
  let row_fields = source.layout.row?.map(rc => {
    let rcf = rc.constructor.name === "Array" ? rc[0] : rc;
    return rcf.field || rcf
  });
  let column_fields = source.layout.column?.map(rc => {
    let rcf = rc.constructor.name === "Array" ? rc[0] : rc;
    return rcf.field || rcf
  });
  let rc_fields = row_fields.concat(column_fields);
  source.layer?.forEach((layer, li) => {
    let enc_fields = Object.keys(layer.mark).map(enc => layer.mark[enc]?.field).filter(d => d !== undefined);
    if (layer.tooltip?.fields) {
      let new_tooltip_fields = [];
      layer.tooltip.fields.forEach(d => {
        if (rc_fields.includes(d.field) || enc_fields.includes(d.field)) new_tooltip_fields.push(d);
      });
      if (new_tooltip_fields.length !== layer.tooltip.fields.length) {
        let rule_tooltip = {
          category: "recommender",
          description: `Adjust tooltips after aggregate`,
          specifier: {
            role: "tooltip",
            layer: {}
          },
          action: "modify",
          option: {
            fields: new_tooltip_fields
          }
        }
        if (layer.name) rule_tooltip.specifier.layer.id = layer.name;
        else rule_tooltip.specifier.layer.index = li;
        rules.push(rule_tooltip);
      }
    }
  });
  return rules;
}

export function translateAggregateLevels(tech, args, line, parsed, source, mapping, processed, config) {
  // do(aggregate_levels,F,La,Lb,L,sum)
  let rules = [];
  let layer_map = mapping[args[3]];
  let layer = source.layer[layer_map.layer];
  let aggOp = (args[4] || "sum");
  let highField = trimFieldString(args[1]), lowField = trimFieldString(args[2]), quantField = trimFieldString(args[0]);
  if (layer !== undefined) {
    let rule = {
      category: "recommender",
      description: `Aggregate for lowField to highField`,
      specifier: {
        role: "layer",
        id: layer.name
      },
      action: "add",
      option: {
        role: "transform",
        transform: [
          {
            "joinaggregate": [
              { "op": aggOp, "field": quantField, "as": quantField }
            ],
            "groupby": [highField]
          },
          { "filter": `datum.${highField} === datum.${lowField}` }
        ]
      }
    };
    rules.push(rule);
  }
  return rules;
}

export function translateDisaggregate(tech, args, line, parsed, source, mapping, processed, config) {
  let rules = [];
  if (args[0] === "pos_X_pos") {
    // do(disaggregate,pos_X_pos,I1)
    let rcKey = mapping[args[1]];
    let rc = ("layout.column" in rcKey ? "column" : "row");
    let rcField = source?.layout?.[rc]?.[rcKey["layout." + rc]];
    if (rcField.constructor.name === "Array") rcField = rcField[0];
    rcField = rcField.field || rcField;
    if (rcField) {
      let rule = {
        category: "recommender",
        description: `Disaggregate ${rc}`,
        specifier: {
          role: "view." + rc,
          field: rcField
        },
        action: "modify",
        option: {
          aggregate: null
        }
      };
      rules.push(rule);
    }
  }

  return rules;
}